import { Ionicons } from '@expo/vector-icons';
// import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ScrollView, StyleSheet, View } from 'react-native';
import { Divider } from 'react-native-paper';

// import Animated, { FadeIn } from 'react-native-reanimated';
import { NonProfitOrgType } from '@/api/models/nonProfitOrgModels';
// import { MAXIMUM_DISTANCE, MINIMUM_DISTANCE } from '@/constants/layout';
import { useColor } from '@/hooks/useColor';
import { HomeFilterData, homeFilterResolver } from '@/lib/validations/HomeFilterSchema';
import { i18n } from '@/utils/i18n';

import BrandedButton from '../buttons/BrandedButton';
import CloseButton from '../buttons/CloseButton';
// import CheckboxAccordionGroup from '../inputs/CheckboxAccordionGroup';
import RadioButtonGroup from '../inputs/RadioButtonGroup';
// import RangeSliderInputField from '../inputs/RangeSliderInputField';
import { OptionType } from '../inputs/types';
import Text from '../Text';

interface FiltersFormProps {
  initialValues: HomeFilterData;
  religionsOption: OptionType[];
  denominationsOptions: OptionType[];
  focusAreaOptions: OptionType[];
  type: NonProfitOrgType;
  onCloseTap: () => void;
  onSubmitTap: (data: HomeFilterData) => void;
  onResetTap: () => void;
}

const FiltersForm = ({
  initialValues,
  // religionsOption,
  // denominationsOptions,
  // focusAreaOptions,
  // type,
  onSubmitTap,
  onCloseTap,
  onResetTap
}: FiltersFormProps) => {
  const colors = useColor();

  // const [enableDistance, setEnableDistance] = useState(initialValues.distance ? true : false);

  const sortLightRatingOptions: OptionType[] = [
    { label: i18n.t('home.filters.htl'), value: 'htl' },
    { label: i18n.t('home.filters.lth'), value: 'lth' }
  ];

  // Strings
  const filters = i18n.t('home.filters.title');
  const sortLightRating = i18n.t('home.filters.sort_light_rating');
  const showResults = i18n.t('home.filters.show_results');
  // const religions = i18n.t('mix.religions');
  // const denominations = i18n.t('mix.denominations');
  // const focusArea = i18n.t('mix.focus_area');
  // const distance = i18n.t('mix.distance');
  // const distanceSubtitle = i18n.t('home.filters.distance_subtitle', {
  //   MINIMUM_DISTANCE: MINIMUM_DISTANCE,
  //   MAXIMUM_DISTANCE: MAXIMUM_DISTANCE
  // });
  const resetFilters = i18n.t('home.filters.reset_filters');
  // const enableDistanceFilter = i18n.t('home.filters.enable_distance');
  // const reviews = i18n.t('mix.reviews');
  // const ratingSubtitle = i18n.t('home.filters.rating_subtitle');

  const {
    control,
    handleSubmit,
    // getValues,
    // setValue,
    formState: { isValid, submitCount, errors },
    setError
  } = useForm<HomeFilterData>({
    defaultValues: initialValues ?? {},
    mode: 'onChange',
    resolver: homeFilterResolver as any
  });

  const onSubmit: SubmitHandler<HomeFilterData> = async (data) => {
    try {
      onSubmitTap(data);
    } catch (error) {
      setError('root', { message: `${error}` });
    }
  };

  // useEffect(() => {
  //   if (!enableDistance) {
  //     setValue('distance', undefined);
  //   } else if (!getValues('distance')) {
  //     setValue('distance', initialValues.distance ?? 150);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [enableDistance, initialValues.distance]);

  return (
    <View style={styles.mainContainer}>
      <View style={styles.headerSection}>
        <View style={styles.header}>
          <CloseButton style={styles.closeButton} onCloseTap={onCloseTap} hitSlop={10} />

          <Text fontWeight="700" style={styles.headerTitle}>
            {filters}
          </Text>
        </View>

        <Divider />
      </View>
      <ScrollView contentContainerStyle={styles.formContainer}>
        <RadioButtonGroup
          control={control}
          name="sort_light_rating"
          options={sortLightRatingOptions}
          groupLabel={
            <View style={styles.sortLightRatingGroupLabel}>
              <Text style={styles.sortLightRatingText} fontWeight="700">
                {sortLightRating}
              </Text>
              <Ionicons size={24} name="information-circle-outline" />
            </View>
          }
          showNoneOption={false}
        />

        {/* ToDO: Uncomment this when we implement the Religions And Denominations Filters */}
        {/* Religions And Denominations Filters */}
        {/* {type === 'CHURCH' && (
          <>
            <Divider />

            <CheckboxAccordionGroup
              name="religions"
              options={religionsOption}
              control={control}
              showError={false}
              groupLabel={religions}
            />

            <CheckboxAccordionGroup
              name="denominations"
              options={denominationsOptions}
              control={control}
              showError={false}
              groupLabel={denominations}
            />
          </>
        )} */}

        {/* ToDO: Uncomment this when we implement the Focus Areas Filters */}
        {/* Focus Areas Filters */}
        {/* <Divider />

        <CheckboxAccordionGroup
          name="programs"
          options={focusAreaOptions}
          control={control}
          showError={false}
          groupLabel={focusArea}
        /> */}

        {/* ToDO: Uncomment this when we implement the Distance Filters */}
        {/* <Divider />
        <View style={styles.enableDistanceContainer}>
          <RadioButton.Android
            value={'enable-distance'}
            status={enableDistance ? 'checked' : 'unchecked'}
            color="black"
            onPress={() => {
              setEnableDistance(!enableDistance);
            }}
          />
          <Text fontWeight="600" style={styles.enableDistanceLabel}>
            {enableDistanceFilter}
          </Text>
        </View>

        {enableDistance && (
          <Animated.View entering={FadeIn}>
            <RangeSliderInputField
              disabled={!enableDistance}
              name="distance"
              control={control}
              showError={false}
              maximumValue={MAXIMUM_DISTANCE}
              minimumValue={MINIMUM_DISTANCE}
              title={distance}
              subtitle={distanceSubtitle}
              step={1}
            />
          </Animated.View>
        )} */}

        {/* ToDO: Uncomment this when we implement the StarRating */}
        {/* <Divider />

          <StarRatingInputField
            name="rating"
            control={control}
            showError={false}
            numberOfStars={5}
            title={reviews}
            subtitle={ratingSubtitle}
          /> */}

        <Divider />

        <BrandedButton
          onPress={handleSubmit(onSubmit)}
          textStyles={styles.showResultsText}
          disabled={!isValid && submitCount > 0}>
          <Text fontWeight="700" style={styles.showResultsText}>
            {showResults}
          </Text>
        </BrandedButton>

        <BrandedButton onPress={onResetTap} backGroundColor="transparent" borderColor={colors.primary} borderWidth={1}>
          <Text fontWeight="700" style={styles.resetFiltersText}>
            {resetFilters}
          </Text>
        </BrandedButton>

        {errors.root !== null && <Text style={styles.errorText}>{errors?.root?.message}</Text>}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    width: '100%'
  },

  headerSection: {
    flexDirection: 'column',
    justifyContent: 'center',
    paddingHorizontal: 18
  },

  header: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 25
  },

  formContainer: {
    flexDirection: 'column',
    gap: 25,
    paddingTop: 25,
    paddingHorizontal: 18
  },

  headerTitle: {
    alignSelf: 'flex-end',
    fontSize: 20,
    color: 'black'
  },

  closeButton: {
    position: 'absolute',
    left: 0
  },

  sortLightRatingGroupLabel: {
    flexDirection: 'row'
  },

  sortLightRatingText: {
    fontSize: 18,
    marginRight: 3,
    color: 'black'
  },

  showResultsText: {
    color: 'white',
    fontSize: 14,
    fontWeight: 700,
    textAlign: 'center'
  },

  resetFiltersText: {
    color: 'black',
    fontSize: 14,
    textAlign: 'center'
  },

  enableDistanceContainer: {
    flexDirection: 'row',
    alignItems: 'center'
  },

  enableDistanceLabel: {
    color: 'black'
  },

  errorText: {
    color: 'red',
    fontSize: 20,
    fontWeight: 'bold'
  }
});

export default FiltersForm;
